function calculate1RM() {
    const liftWeight = parseInt(document.getElementById('liftWeight').value);
    const rpe = parseInt(document.getElementById('rpe').value);
    let repetitions = parseInt(document.getElementById('repetitions').value);

    // Validate inputs
    if (isNaN(liftWeight) || isNaN(repetitions) || liftWeight <= 0 || repetitions <= 0) {
        alert('Indtast kun positive numeriske værdier!');
        return;
    }

    // Adjust repetitions based on RPE, if provided and valid
    if (!isNaN(rpe) && rpe >= 1 && rpe <= 10) {
        repetitions += (10 - rpe); // Adjust repetitions according to RPE
    }
    
    let estimated1RM;

        if (repetitions <= 10) {
                estimated1RM = liftWeight / (1.0278 - (0.0278 * repetitions));
            } 
        else {
            estimated1RM = liftWeight * (1 + (repetitions / 30));
        }

    document.getElementById('result').innerHTML = `Estimeret 1RM: ${estimated1RM.toFixed(2)} kg`;

    // Define repPercentages within the function for clarity and to ensure it's available
    const repPercentages = [
        { reps: 1, percentage: 1.00 },
        { reps: 2, percentage: 0.97 },
        { reps: 3, percentage: 0.94 },
        { reps: 4, percentage: 0.92 },
        { reps: 5, percentage: 0.89 },
        { reps: 6, percentage: 0.86 },
        { reps: 7, percentage: 0.83 },
        { reps: 8, percentage: 0.81 },
        { reps: 9, percentage: 0.78 },
        { reps: 10, percentage: 0.75 },
        { reps: 11, percentage: 0.73 },
        { reps: 12, percentage: 0.71 },
        { reps: 13, percentage: 0.70 },
        { reps: 14, percentage: 0.68 },
        { reps: 15, percentage: 0.67 },
        { reps: 16, percentage: 0.65 },
        { reps: 17, percentage: 0.64 },
        { reps: 18, percentage: 0.63 },
        { reps: 19, percentage: 0.61 },
        { reps: 20, percentage: 0.60 },
        { reps: 21, percentage: 0.59 },
        { reps: 22, percentage: 0.58 },
        { reps: 23, percentage: 0.57 },
        { reps: 24, percentage: 0.56 },
        { reps: 25, percentage: 0.55 },
        { reps: 26, percentage: 0.54 },
        { reps: 27, percentage: 0.53 },
        { reps: 28, percentage: 0.52 },
        { reps: 29, percentage: 0.51 },
        { reps: 30, percentage: 0.50 },
    ];

    const resultBody = document.getElementById('resultBody');
    resultBody.innerHTML = ''; // Clear previous results

// Populate the table with calculated results
    for (let percent = 100; percent >= 50; percent -= 5) {
        let weightAtPercentage = estimated1RM * (percent / 100);
        // Improved finding mechanism to avoid "N/A"
        let closest = repPercentages.find(item => Math.abs(item.percentage - (percent / 100)) < 0.05);
        let repsDisplay = closest ? closest.reps : 'N/A';
        
        // Create a new row in the table for each percentage
        let row = resultBody.insertRow();
        let cell1 = row.insertCell(0); // For percentage
        let cell2 = row.insertCell(1); // For weight
        let cell3 = row.insertCell(2); // For repetitions

        cell1.innerHTML = `${percent}%`;
        cell2.innerHTML = `${weightAtPercentage.toFixed(2)} kg`;
        cell3.innerHTML = closest.reps;
    }

    // Ensure the table is visible
    document.getElementById('resultTable').style.display = 'table';
}
